import { notifications } from '@mantine/notifications'
import classes from './scanAlert.module.css'

/**
 * Only ever one scan alert on screen. Each is centred at the same spot, so without a
 * shared id a quick second scan would stack one exactly on top of the other.
 */
const SCAN_ALERT_ID = 'zebra-scan-alert'

/**
 * Feedback for a Zebra scan (BD-8393, BD-8396).
 *
 * Centred rather than edge-stacked, and accented orange: none of these states is a fault
 * the team member has to fix. A wrong scan just needs repeating, and a duplicate means
 * the crate is already accounted for. Red read as something having gone wrong.
 *
 * Scoped deliberately to this flow — the app's other toasts keep their own position
 * and colour.
 */
export function showScanAlert({ title, message }: { title?: string, message: string }) {
  // Re-showing a live id is ignored, so clear it first: a second scan must replace the
  // first alert and restart its timer rather than be swallowed.
  notifications.hide(SCAN_ALERT_ID)
  notifications.show({
    id: SCAN_ALERT_ID,
    title,
    message,
    color: 'orange',
    withBorder: true,
    classNames: { root: classes.scanAlert },
  })
}
